import React, { useState } from 'react';

import DashboardHomeEmployee from '../components/Employee/DashboardHomeEmployee';

const EmployeeDashboard = () => {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);


    return (
        <div className="min-h-screen bg-background">

            <DashboardHomeEmployee
                sidebarCollapsed={sidebarCollapsed}
                onMenuClick={() => setMobileMenuOpen(true)}
            />


        </div>
    );
};

export default EmployeeDashboard;